module.exports = __webpack_public_path__ + "static/fbeauty__step-2-9a7a6a6e7121f0e80ffed73ba911e312.jpg";